import { IsArray, IsString } from "class-validator";

import { IsReference } from "../helpers/decorators";

import { WebEntry } from "./webEntry";

export class ProductVariation extends WebEntry {
  public get type() {
    return "productVariation" as const;
  }

  @IsString()
  identifier: string;
  @IsReference("product")
  product: string;
  @IsReference("faculty")
  faculty: string;
  @IsArray()
  @IsString({ each: true })
  variations: Array<string>;
}
